import { BrowserRouter, Route, Switch } from "react-router-dom";

import AuthContextProvider from "./contexts/AuthContext";

import AdminRoom from "./pages/AdminRoom";
import Home from "./pages/Home";
import NewRoom from "./pages/NewRoom";
import Room from "./pages/Room";

import GlobalStyle from "./styles/global";

const App = () => {
  return (
    <BrowserRouter>
      <GlobalStyle />
      <AuthContextProvider>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/rooms/new" exact component={NewRoom} />
          <Route path="/rooms/:id" component={Room} />
          <Route path="/admin/rooms/:id" component={AdminRoom} />
        </Switch>
      </AuthContextProvider>
    </BrowserRouter>
  );
};

export default App;
